// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.DashboardViewer.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * This component is intended to show only report body content.
 * Parameters locate in the params property.
 * id: required. Id of report part.
 *
 * Example build URI:
 * var ContentRoutes = require('routes/Izenda.ContentRoutes');
 * var uri = routeUtils.getViewerUrl(\
 *   'Dashboard',
 *   {
 *     id: 'e395dca2-088a-4ff2-8c54-9412fca495bf',
 *   }
 * );
 * // result: /viewer/dashboard/e395dca2-088a-4ff2-8c54-9412fca495bf
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import connect from 'share/enhancers/Izenda.Connect';
import DashboardStore from 'logic/Izenda.DashboardStore';
import PrintingUtils from 'share/utils/Izenda.PrintingUtils';
import PrintConstants from 'logic/data/Izenda.PrintConstants';
import { forEach} from 'lodash/fp';


@connect({ toClass: true })
class DashboardViewer extends Component {
  static displayName = 'DashboardViewer';

  constructor(props) {
    super(props);
    this.state = {
      renderListeners: null,
      scaleX: 1,
      cellWidth: 0
    };

    this.store = new DashboardStore();
    const { loader, location, params } = props;
    this.store.readURLOptions(location.query);

    loader.startLoading();
    this.store.loadDashboard(params.id).then(() => {
      const dashboard = this.store.dashboardDetail.dashboard;
      const activeDashboardParts = dashboard.activeDashboardParts;
      const listeners = [];
      forEach(part => {
        listeners.push(PrintingUtils.createPartRenderPromise(part.id));
      }, activeDashboardParts);
      this.setState({
        renderListeners: listeners
      });
    });
  }

  /**
     * get scale on x-axis.
     */
  getScaleX() {
    const dpi = PrintingUtils.getDPI();
    const node = ReactDOM.findDOMNode(this.refs.dashboardContent);
    const pageSize = PrintConstants.getPageSize();
    const widthPageSizeInPx = dpi * pageSize.widthInInches;
    const nodeWidthInPx = node.getBoundingClientRect().width;

    this.setState({
      scaleX: widthPageSizeInPx / nodeWidthInPx,
      cellWidth: nodeWidthInPx / 12
    });
  }

  componentDidMount() {
    this.getScaleX();
  }

  render() {
    const DashboardGridContent = require('modules/Dashboard/DashboardDesigner/DashboardGrid/Izenda.DashboardGridContent');
    const style = PrintingUtils.buildScaleStyle(this.state.scaleX);

    return (
      <div className='u_fullSize izenda-DashboardViewer u_fullInlineBlock' ref='dashboardContent' style={style}>
        <DashboardGridContent
          store={this.store}
          dashboardDetail={this.store.dashboardDetail}
          printingMode
          viewMode
          cellWidth={this.state.cellWidth}
          renderListeners={this.state.renderListeners}
        />
      </div>
    );
  }
}

export default DashboardViewer;



// WEBPACK FOOTER //
// ./ui/share/components/views/Izenda.DashboardViewer.js